var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9110",
    "data-name": "Group 9110",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.761,
    height: 34.858,
    viewBox: "0 0 34.761 34.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.761,
    height: 34.858,
    fill: "#03494e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.664,5.1A17.454,17.454,0,0,0,5.01,5.1,17.734,17.734,0,0,0,.244,20.5a5.576,5.576,0,0,0,5.528,4.694h.554a.807.807,0,0,0,.806-.806V21.2a.806.806,0,0,0-.807-.806H5.772a.792.792,0,0,1-.787-.663A12.908,12.908,0,0,1,8.408,8.5,12.628,12.628,0,0,1,26.267,26.354a12.989,12.989,0,0,1-11.261,3.525.792.792,0,0,1-.666-.789l.005-3.878c1.144.009,2.312.021,2.566.021a8.154,8.154,0,0,0,6.136-2.459,7.887,7.887,0,0,0,.2-10.484A7.758,7.758,0,0,0,17.6,9.6a7.856,7.856,0,0,0-5.8,2.287,8.2,8.2,0,0,0-2.276,5.952v.127c0,.339,0,1.137,0,1.99,0,.141,0,.283,0,.427h0l.005,8.7a5.575,5.575,0,0,0,4.7,5.532,18.373,18.373,0,0,0,2.918.236,17.688,17.688,0,0,0,12.508-5.106,17.453,17.453,0,0,0,0-24.654M14.333,17.844a3.473,3.473,0,0,1,.868-2.555,3.021,3.021,0,0,1,4.422.159,3.042,3.042,0,0,1-.08,4.041,3.413,3.413,0,0,1-2.633.94c-.231,0-1.364-.009-2.572-.021,0-1.146-.005-2.327-.005-2.564",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenny);
export default __webpack_public_path__ + "static/media/penny.aebd6b216d6a201097e0b38e6faaef77.svg";
export { ForwardRef as ReactComponent };